/* yungi · Pop-up ticket à gratter — logique (Klaviyo onsite + code auto + proxy anti-bloqueur) */
(function(){
  var root = document.getElementById('ygp');
  if(!root) return;
  var reopen = document.getElementById('ygp-reopen');
  var cfg = root.dataset;
  var KEY = cfg.key || 'XXULRw';
  var EMAIL_LIST = cfg.emailList || 'Tu9c3e';
  var CODE = cfg.code || 'BIENVENUE10';
  var REDIRECT = cfg.redirect || '/products/creme-gua-sha';
  var PROXY = (cfg.proxy || '').trim();
  var THRESH = (parseInt(cfg.threshold,10) || 30) / 100;
  var DELAY = (parseInt(cfg.delay,10) || 9) * 1000;
  var DAYS = parseInt(cfg.days,10) || 7;
  var LABEL = cfg.scratchLabel || 'GRATTEZ ICI';
  var SAVED_EMAIL = '';
  var design = window.Shopify && Shopify.designMode;
  var STORE = 'ygp_pop_v1';
  var DBG = /[?&]ygpdebug/.test(window.location.search);
  function dbg(m){ if(DBG){ try{ alert('[pop-up] '+m); }catch(e){} } }

  function state(){ try { var v=localStorage.getItem(STORE); return v ? JSON.parse(v) : null; } catch(e){ return null; } }
  function seen(){ var o=state(); if(!o) return false; if(o.done) return true; return (Date.now()-o.t) < DAYS*864e5; }
  function isDone(){ var o=state(); return !!(o && o.done); }
  function mark(done){ try { localStorage.setItem(STORE, JSON.stringify({t:Date.now(), done:!!done})); } catch(e){} }
  function openP(){ root.classList.add('is-open'); document.body.style.overflow='hidden'; if(reopen) reopen.classList.remove('is-shown'); }
  function closeP(){ root.classList.remove('is-open'); document.body.style.overflow=''; if(!root.dataset.done) mark(false); if(reopen && !root.dataset.reopenDismissed) reopen.classList.add('is-shown'); }
  var reopenBtn = reopen ? reopen.querySelector('[data-pop-reopen]') : null;
  if(reopenBtn) reopenBtn.addEventListener('click', function(){ openP(); setTimeout(initScratch, 60); });
  var reopenDismiss = reopen ? reopen.querySelector('[data-pop-reopen-dismiss]') : null;
  if(reopenDismiss) reopenDismiss.addEventListener('click', function(e){ e.stopPropagation(); root.dataset.reopenDismissed='1'; reopen.classList.remove('is-shown'); });
  function step(n){ root.querySelectorAll('.ygp-panel').forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-step')===String(n)); }); }

  root.querySelectorAll('[data-pop-close]').forEach(function(b){ b.addEventListener('click', closeP); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && root.classList.contains('is-open')) closeP(); });

  // Secours : si l'appel direct vers Klaviyo est bloqué (VPN anti-pub, DNS filtrant),
  // on rejoue la même charge via le proxy (domaine neutre, requête simple sans preflight).
  function viaProxy(path, body, label){
    if(!PROXY) return Promise.resolve();
    return fetch(PROXY, { method:'POST', headers:{ 'Content-Type':'text/plain' }, body: JSON.stringify({ path: path, payload: body }) })
      .then(function(r){ dbg(label+' (secours proxy) : HTTP '+r.status+(r.ok?' — reçu OK':' — REFUSÉ')); return r; })
      .catch(function(e){ dbg(label+' (secours proxy) : BLOQUÉ aussi. Détail : '+e); });
  }

  function subscribe(listId, opts){
    if(!KEY || !listId || !opts) return Promise.resolve();
    var pa = {};
    if(opts.email) pa.email = opts.email;
    if(opts.phone_number) pa.phone_number = opts.phone_number;
    var subs = {};
    (opts.channels || []).forEach(function(ch){
      if(ch === 'email') subs.email = { marketing: { consent: 'SUBSCRIBED' } };
      if(ch === 'sms')   subs.sms   = { marketing: { consent: 'SUBSCRIBED' } };
    });
    pa.subscriptions = subs;
    var body = { data: { type:'subscription', attributes: { custom_source: 'Pop-up yungi', profile: { data: { type:'profile', attributes: pa } } }, relationships: { list: { data: { type:'list', id: listId } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(KEY), {
      method:'POST', headers:{ 'Content-Type':'application/json', 'revision':'2025-07-15' }, body: JSON.stringify(body)
    }).then(function(r){ dbg('Email → Klaviyo : HTTP '+r.status+(r.ok?' — reçu OK':' — REFUSÉ')); return r; })
      .catch(function(e){ dbg('Email → Klaviyo : BLOQUÉ (réseau / anti-pub / VPN) → bascule sur le proxy'); return viaProxy('subscriptions', body, 'Email → Klaviyo'); });
  }

  function saveProfile(opts){
    if(!KEY || !opts) return Promise.resolve();
    var pa = {};
    if(opts.email) pa.email = opts.email;
    if(opts.phone_number) pa.phone_number = opts.phone_number;
    if(opts.properties) pa.properties = opts.properties;
    var body = { data: { type:'profile', attributes: pa } };
    return fetch('https://a.klaviyo.com/client/profiles/?company_id='+encodeURIComponent(KEY), {
      method:'POST', headers:{ 'Content-Type':'application/json', 'revision':'2025-07-15' }, body: JSON.stringify(body)
    }).then(function(r){ dbg('Numéro → Klaviyo : HTTP '+r.status+(r.ok?' — reçu OK':' — REFUSÉ')); return r; })
      .catch(function(e){ dbg('Numéro → Klaviyo : BLOQUÉ (réseau / anti-pub / VPN) → bascule sur le proxy'); return viaProxy('profiles', body, 'Numéro → Klaviyo'); });
  }

  function shopifyCustomer(email){
    try {
      var params = new URLSearchParams();
      params.append('form_type','customer');
      params.append('utf8','✓');
      params.append('contact[email]', email);
      params.append('contact[tags]', 'newsletter, popup-yungi');
      return fetch('/contact', { method:'POST', headers:{ 'Content-Type':'application/x-www-form-urlencoded' }, body: params.toString() })
        .then(function(r){ dbg('Email → Shopify : HTTP '+r.status); return r; })
        .catch(function(e){ dbg('Email → Shopify : bloqué. Détail : '+e); });
    } catch(e){ return Promise.resolve(); }
  }

  // Scratch canvas — feuille métallisée dorée
  var canvas = root.querySelector('[data-pop-canvas]');
  var claimWrap = root.querySelector('[data-pop-claim-wrap]');
  var hint = root.querySelector('[data-pop-hint]');
  var ctx, drawing=false, revealed=false, inited=false;
  function reveal(){
    if(revealed) return; revealed=true;
    if(canvas) canvas.style.opacity='0';
    if(hint) hint.style.display='none';
    if(claimWrap) claimWrap.classList.add('is-shown');
  }
  function initScratch(){
    if(inited || !canvas) return; inited=true;
    var wrap = canvas.parentNode, r = wrap.getBoundingClientRect();
    var dpr = window.devicePixelRatio || 1;
    canvas.width = Math.round(r.width*dpr); canvas.height = Math.round(r.height*dpr);
    ctx = canvas.getContext('2d'); ctx.scale(dpr,dpr);
    var g = ctx.createLinearGradient(0,0,0,r.height);
    g.addColorStop(0,'#9e7212'); g.addColorStop(.18,'#d4af37'); g.addColorStop(.42,'#f6e7a8');
    g.addColorStop(.58,'#e8c558'); g.addColorStop(.8,'#caa12f'); g.addColorStop(1,'#8a6410');
    ctx.fillStyle=g; ctx.fillRect(0,0,r.width,r.height);
    var sh = ctx.createLinearGradient(0,r.height,r.width,0);
    sh.addColorStop(0,'rgba(255,255,255,0)'); sh.addColorStop(.46,'rgba(255,255,255,0)'); sh.addColorStop(.5,'rgba(255,255,255,.45)'); sh.addColorStop(.54,'rgba(255,255,255,0)'); sh.addColorStop(1,'rgba(255,255,255,0)');
    ctx.fillStyle=sh; ctx.fillRect(0,0,r.width,r.height);
    ctx.textAlign='center'; ctx.textBaseline='middle';
    ctx.font='800 15px Plus Jakarta Sans, Arial, sans-serif';
    ctx.fillStyle='rgba(255,255,255,.5)'; ctx.fillText(LABEL, r.width/2+1, r.height/2+1);
    ctx.fillStyle='rgba(90,64,8,.7)'; ctx.fillText(LABEL, r.width/2, r.height/2);
    ctx.globalCompositeOperation='destination-out';
  }
  function ptr(e){ var r=canvas.getBoundingClientRect(); var t=(e.touches&&e.touches[0])?e.touches[0]:e; return {x:t.clientX-r.left, y:t.clientY-r.top}; }
  function scratch(e){ if(!drawing||revealed||!ctx) return; var p=ptr(e); ctx.beginPath(); ctx.arc(p.x,p.y,34,0,6.2832); ctx.fill(); if(e.cancelable) e.preventDefault(); check(); }
  function check(){ if(revealed) return; try{ var w=canvas.width,h=canvas.height; var d=ctx.getImageData(0,0,w,h).data; var cl=0,tot=0; for(var i=3;i<d.length;i+=400){ tot++; if(d[i]===0) cl++; } if(tot && cl/tot>THRESH){ reveal(); } }catch(err){} }
  if(canvas){
    canvas.addEventListener('mousedown', function(e){ drawing=true; scratch(e); });
    canvas.addEventListener('mousemove', scratch);
    window.addEventListener('mouseup', function(){ drawing=false; });
    canvas.addEventListener('touchstart', function(e){ drawing=true; scratch(e); }, {passive:false});
    canvas.addEventListener('touchmove', scratch, {passive:false});
    canvas.addEventListener('touchend', function(){ drawing=false; });
  }
  var claimBtn = root.querySelector('[data-pop-claim]');
  if(claimBtn) claimBtn.addEventListener('click', function(){ step(2); });

  // Étape 2 — email
  var emailForm = root.querySelector('[data-pop-email-form]');
  var err = root.querySelector('[data-pop-err]');
  if(emailForm) emailForm.addEventListener('submit', function(e){
    e.preventDefault();
    var email = emailForm.email.value.trim();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ err.textContent='Entrez un email valide.'; return; }
    err.textContent='';
    SAVED_EMAIL = email;
    subscribe(EMAIL_LIST, { email: email, channels: ['email'] });
    shopifyCustomer(email);
    step(3);
  });

  // Étape 3 — numéro + indicatif
  var phoneForm = root.querySelector('[data-pop-phone-form]');
  var cc = root.querySelector('[data-pop-cc]');
  var err2 = root.querySelector('[data-pop-err2]');
  function finish(){ root.dataset.done='1'; mark(true); step(4); }
  if(phoneForm) phoneForm.addEventListener('submit', function(e){
    e.preventDefault();
    var dial = cc ? cc.value : '33';
    var local = (phoneForm.phone.value||'').replace(/[^\d]/g,'').replace(/^0+/,'');
    if(local.length < 6){ err2.textContent='Entrez un numéro valide.'; return; }
    err2.textContent='';
    var e164 = '+'+dial+local;
    saveProfile({ email: SAVED_EMAIL || undefined, phone_number: e164, properties: { 'WhatsApp': e164, 'Source numero': 'Pop-up yungi' } });
    finish();
  });
  var skip = root.querySelector('[data-pop-skip]');
  if(skip) skip.addEventListener('click', finish);

  // CTA final — applique le code puis renvoie sur la page courante
  var cta = root.querySelector('[data-pop-cta]');
  if(cta){
    cta.addEventListener('click', function(e){
      e.preventDefault();
      mark(true);
      var here = window.location.pathname + window.location.search;
      if(!here || here === '/discount' || here.indexOf('/discount/') === 0){ here = REDIRECT; }
      window.location.href = '/discount/' + encodeURIComponent(CODE) + '?redirect=' + encodeURIComponent(here);
    });
  }

  var fired=false;
  function trigger(){ if(fired) return; fired=true; openP(); setTimeout(initScratch, 60); }
  if(design){ openP(); setTimeout(initScratch, 60); return; }
  if(DBG){ dbg('MODE TEST : pop-up forcé, déjà-vu ignoré. Clé '+KEY+' · liste '+EMAIL_LIST+' · proxy '+(PROXY||'aucun')); trigger(); return; }
  if(seen()){ if(reopen && !isDone()) reopen.classList.add('is-shown'); return; }
  setTimeout(trigger, DELAY);
  document.addEventListener('mouseout', function(e){ if(e.clientY<=0 && !e.relatedTarget) trigger(); });
})();
